/**
 * ラベル
 *
 * nodes.name: room_labelで表示する名前
 * useDoor: label表示に使う door
 * useIcons: label表示に使う icons
 */
export default {
  nodes: {
    default: {
      name: ""
    },
    west: {
      name: "洋室"
    },
    ldk: {
      name: "キッチン"
    },
    tatami: {
      name: "和室"
    },
    balcony: {
      name: "バルコニー"
    },
    sanitary: {
      name: "トイレ・洗面"
    },
    bath: {
      name: "浴室"
    },
    corridor: {
      name: "廊下"
    },
    closet: {
      name: "収納"
    },
    meter_box: {
      name: "メーターボックス"
    },
    bath_toilet_washing_room: {
      name: "トイレ・洗面・浴室"
    },
    porch: {
      name: "ポーチ"
    }
  },
  useDoor: {
    entrance_door: {
      name: "エントランス"
    },
    bathroom_door: {
      name: "バスルーム"
    }
  },
  useIcons: {
    kitchen_counter: {
      name: "キッチン"
    },
    toilet: {
      name: "トイレ"
    }
  }
};
